import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Distpicker from 'v-distpicker'

import normalize from 'normalize.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/styles/index.scss' // global css

import Element from 'element-ui'
import NProgress from 'nprogress' // progress bar
import VCharts from 'v-charts'

import { getToken } from './utils/auth'
import * as filters from './filters' // global filters

Vue.prototype.$store = store


Vue.component('v-distpicker', Distpicker)
Vue.use(VCharts)
Vue.use(normalize)
Vue.use(Element)
Vue.config.devtools = process.env.NODE_ENV !== 'production'
Vue.config.productionTip = false

//配置nprogress
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

// register global utility filters.
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

const whiteList = ['/login', '/authredirect', '/register','/join', '/join/company'] //白名单

router.beforeEach(async (to, from, next) => {
	NProgress.start()

	const hasToken = getToken()
	if (hasToken) {
		//判断是否有token
		if (to.path === '/login') {
			next({ path: '/' })
		} else {
			const hasUser = store.getters.user && Object.keys(store.getters.user).length !== 0

			//判断是否有用户信息
			if(hasUser){
				if(to.matched.length == 0){
					router.addRoutes(store.getters.routes)
					next({ ...to, replace: true })
				}else{
					next()
				}
			}else {
				try {
					store.dispatch('user/getInfo').then(() => {
						router.addRoutes(store.getters.routes)
						return next({ ...to, replace: true })
					})
				} catch (error) {
					await store.dispatch('user/clearToken')
					next(`/login`)
					NProgress.done()
				}
			}
		}
	} else {
		// 在免登录白名单，直接进入
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else {
			next(`/login`)
		}
	}
})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})

/**
 * 初始化vue
 */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})
